var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoresRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 24 24"
    },
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cart"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff1200",
    d: "M20,13H4c-0.7,0-1.1,0.6-1,1.2l1.4,6.2c0.2,0.9,1,1.6,2,1.6h11.1c1,0,1.8-0.7,2-1.6l1.4-6.2C21.1,13.6,20.6,13,20,13z     M11,18c0,0.5-0.4,1-1,1s-1-0.5-1-1v-2c0-0.5,0.4-1,1-1s1,0.5,1,1V18z M15,18c0,0.5-0.4,1-1,1s-1-0.5-1-1v-2c0-0.5,0.4-1,1-1    s1,0.5,1,1V18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff1200",
    d: "M21,8h-2.2l-1.9-4.8c-0.4-1-1.6-1.5-2.6-1.1c-1,0.4-1.5,1.6-1.1,2.6L14.5,8H9.5l1.3-3.3c0.4-1-0.1-2.2-1.1-2.6    c-1-0.4-2.2,0.1-2.6,1.1L5.2,8H3c-1.1,0-2,0.9-2,2v1c0,0.6,0.4,1,1,1h20c0.6,0,1-0.4,1-1v-1C23,8.9,22.1,8,21,8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoresRed);
export default __webpack_public_path__ + "static/media/StoresRed.c49864d43f6530253950d75c6733a692.svg";
export { ForwardRef as ReactComponent };